import '../../_rollupPluginBabelHelpers-a38db067.js';
import '../utils.js';
import '../core/core-utils.js';
import '../core/parser.js';
import '../core/style-function.js';
import { system } from '../core/system.js';

const config = {
  gridGap: {
    property: 'gridGap'
  },
  gap: {
    property: 'gap'
  },
  gridRowGap: {
    property: 'gridRowGap'
  },
  rowGap: {
    property: 'rowGap'
  },
  gridColumnGap: {
    property: 'gridColumnGap'
  },
  columnGap: {
    property: 'columnGap'
  },
  gridRow: {
    property: 'gridRow'
  },
  gridColumn: {
    property: 'gridColumn'
  },
  gridAutoFlow: {
    property: 'gridAutoFlow'
  },
  gridAutoRows: {
    property: 'gridAutoRows'
  },
  gridAutoColumns: {
    property: 'gridAutoColumns'
  },
  gridTemplateRows: {
    property: 'gridTemplateRows'
  },
  gridTemplateColumns: {
    property: 'gridTemplateColumns'
  },
  gridTemplateAreas: {
    property: 'gridTemplateAreas'
  },
  gridArea: {
    property: 'gridArea'
  }
};
const grid = system(config);

export { grid };
